import { animate, style, transition, trigger } from "@angular/animations";
import { Component } from "@angular/core";
import { Capacitor } from "@capacitor/core";

@Component({
    selector: "app-referrer",
    imports: [],
    templateUrl: "./app-referrer.html",
    styleUrl: "./app-referrer.scss",
    animations: [
        trigger("slideAnimation", [
            transition(":enter", [style({ transform: "translateY(100%)" }), animate("400ms ease-out")]),
            transition(":leave", [animate("400ms ease-in", style({ transform: "translateY(100%)" }))])
        ])
    ]
})
export class AppReferrer {
    public isVisible: boolean = true;
    public isMobile: boolean = false;
    public isNativeApp: boolean = false;

    ngOnInit() {
        this.detectPlatform();
    }

    private detectPlatform() {
        if (Capacitor?.isNativePlatform()) {
            this.isNativeApp = true;
            this.isMobile = true;
        } else {
            this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            this.isNativeApp = false;
        }
    }

    close() {
        this.isVisible = false;
    }

    openApp() {
        const isAndroid = /Android/i.test(navigator.userAgent);
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (isAndroid) {
            window.location.href = "eforsyning://";

            const timeout = setTimeout(() => {
                window.location.href = "https://play.google.com/store/apps/details?id=dk.dffedb.eforsyning";
            }, 1500);

            window.addEventListener("pagehide", () => clearTimeout(timeout), { once: true });
        } else if (isIOS) {
            window.location.href = "https://eforsyning.page.link/open";

            const timeout = setTimeout(() => {
                window.location.href = "apps.apple.com/dk/app/e-forsyning/id694578367";
            }, 1500);

            window.addEventListener("pagehide", () => clearTimeout(timeout), { once: true });
        }
    }
}
